<div class="package" [class.selected]="selected" [id]="innerId">
  <label class="form-control-label">{{ package }}</label>
  <div id="default-licenses" class="row no-gutters justify-content-between">
    <ng-container *ngFor="let license of licenses" [ngbTooltip]="license">
      <div class="license" *ngIf="hasIcon(license)">
        <app-svg-icon
          class="center icon"
          [icon]="'tool-icons/' + license"
        ></app-svg-icon>
        <span class="center">{{
          LicenseCodeDisplayName[license]
            ? LicenseCodeDisplayName[license]
            : license
        }}</span>
      </div>
    </ng-container>
  </div>
</div>
